// extracted by mini-css-extract-plugin
module.exports = {"Col":"Col_Col__33kRm","Col_scrollable":"Col_Col_scrollable__17CdE"};